export const handleKeyDownDisable = (keys: string[] = ['e', 'E', '+', '-']) => {
  return (e: React.KeyboardEvent | KeyboardEvent) => {
    if (keys.includes(e.key)) e.preventDefault();
  };
};

export const handleKeyDownDisableNumber = handleKeyDownDisable(['e', 'E', '+', '-']);

export const handledKeyDownCallBack = (keys: string[] = ['Enter'], fn?: (...args: any) => any) => {
  return (e: React.KeyboardEvent | KeyboardEvent) => {
    if (keys.includes(e.key)) {
      e.preventDefault();
      fn?.(e);
    }
  };
};

export const handledKeyDownCallBackEnter = (fn?: (...args: any) => any) => handledKeyDownCallBack(['Enter'], fn);
